import moment from 'moment';
import 'moment/locale/fr';
import 'moment/locale/es';
import 'moment/locale/de';
import 'moment/locale/is';
import 'moment/locale/nb';
import 'moment/locale/da';
import 'moment/locale/ar-kw';
import 'moment/locale/zh-cn';
import 'moment/locale/nl';
import 'moment/locale/fi';
import 'moment/locale/el';
import 'moment/locale/it';
import 'moment/locale/ja';
import 'moment/locale/ko';
import 'moment/locale/pl';
import 'moment/locale/pt';
import 'moment/locale/sv';

const LANGUAGE_TO_MOMENT_LOCALE = {
    no: 'nb',
    zh_CN: 'zh-cn',
    ar_KW: 'ar-kw',
};

export function mapLanguageToMomentLocale(languageCode) {
    if (!languageCode) {
        return 'en';
    }
    if (LANGUAGE_TO_MOMENT_LOCALE[languageCode]) {
        return LANGUAGE_TO_MOMENT_LOCALE[languageCode];
    }
    return languageCode.replace('_', '-').toLowerCase();
}

export function setMomentLocale(languageCode) {
    const momentLocale = mapLanguageToMomentLocale(languageCode);
    moment.locale(momentLocale);
    return momentLocale;
}

export default moment;
